import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSyllabusPaginationAction } from "../../redux/actions/syllabusActions";
import {
  SYLLABUS_MODAL_ACTION_TYPE,
  SYLLABUS_ALL_ACTIONS_TYPE,
} from "../../redux/actions-type";
import SyllabusData from "./components/SyllabusData";
import GlobalHead from "../../globalComponents/GlobalHead/GlobalHead";

const SyllabusPage = () => {
  const dispatch = useDispatch();
  const { totalLength, loading, syllabusData } = useSelector(
    (state) => state.syllabusPagination
  );
  const { syllabusSearchValues } = useSelector((state) => state.searchValues);
  const { selectedCourse } = useSelector((state) => state.syllabusCourse);

  let userData = JSON.parse(localStorage.getItem("userData"));
  userData =
    userData.role !== "super-admin"
      ? userData.profiles
      : JSON.parse(localStorage.getItem("userData"));

  const openModal = () => {
    dispatch({
      type: SYLLABUS_MODAL_ACTION_TYPE.GET_SYLLABUS_MODAL,
      payload: { data: {}, openModal: true },
    });
  };

  useEffect(() => {
    dispatch(getSyllabusPaginationAction());

    return () => {
      dispatch({
        type: SYLLABUS_ALL_ACTIONS_TYPE.RESET_SYLLABUS_PAGINATION,
      });
    };
  }, []);
  return (
    <div className="details-page teachers-page ">
      <GlobalHead
        searchData={""}
        openModal={openModal}
        DATA_SEARCH_VALUE={"SYLLABUS_SEARCH_VALUE"}
        dataSearchValues={syllabusSearchValues}
        statusType="syllabus"
        count={totalLength}
      />

      <SyllabusData
        userData={userData}
        selectedCourse={selectedCourse}
      />
    </div>
  );
};

export default SyllabusPage;
